import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideBuilding2, lucideCircleCheck, lucideHome, lucideArrowLeft } from '@ng-icons/lucide';
import { UserService } from '../../../core/auth/services/user.service';
import { Role } from '../../../core/auth/user.model';
import { AppStateService } from '../../../core/services/app-state.service';

@Component({
  selector: 'app-auth-profile',
  standalone: true,
  imports: [NgIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({ lucideBuilding2, lucideCircleCheck, lucideHome, lucideArrowLeft })],
  templateUrl: './auth-profile.component.html',
  styleUrl: './auth-profile.component.css',
})
export class AuthProfileComponent {
  protected readonly userService = inject(UserService);
  protected readonly state = inject(AppStateService);
  protected readonly router = inject(Router);



  protected handleProfileChoice(type: 'landlord' | 'tenant'): void {
    const role = type === 'landlord' ? Role.LANDLORD : Role.TENANT;
    this.userService.update({ activeRole: role }).subscribe({
      next: () => {
        if (type === 'landlord') {
          this.router.navigate(['/setup/welcome-owner']);
        } else {
          const user = this.userService.getCurrentUserSync();
          this.state.authenticate(type, user?.name || '', user?.email || '', true);
          this.router.navigate(['/']);
        }
      },
      error: (err) => {
        console.error('Failed to update profile role', err);
      }
    });
  }
}
